import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const LinkTreeColorIcon = (props: IconProps) => (
  <Icon
    fill='currentColor'
    height='100%'
    viewBox='0 0 711.6 500.3'
    width='auto'
    {...props}
  >

      <g
        id='layer1'
        transform='translate(-34.813623,-47.365765)'
      >
        <g
          id='g46'
          transform='matrix(0.26458333,0,0,0.26458333,-15.67531,43.64805)'
        >
          <g
            id='g18'
            transform='matrix(0.857143,0,0,0.857143,8,306)'
          >
            <path
              id='path993'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M1666.4,1043.3h236.4v531.3h-236.4V1043.3'
            />
            <path
              id='path991'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M1119.8,499.4h401.7l-286-270.7l157.6-160.6l272.1,278.3V-49.6h236.4v395.9l272-278.3     l157.6,160.6l-286,270.7H2447v223.9h-404.3l287.3,278.3l-157.6,156.9l-390.3-390.9l-390.3,390.9l-157.6-156.9l287.3-278.3h-404.2     V499.4H1119.8'
            />
          </g>
        </g>
      </g>
  </Icon>
);

export default LinkTreeColorIcon;
